import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import success from "../../assets/images/succesasset.png";
import failed from "../../assets/images/failed.png";
import CryptoJS from 'crypto-js';
const PaymentGateway = () => {
  const location = useLocation();
  const history = useHistory()
  const [data, setData] = useState(null)
  const [time, setTime] = useState(5)

  useEffect(() => {
    const search = location.state?.search ?? location.search
    if (search) {
      let searchParams = new URLSearchParams(search)
      var rawData = CryptoJS.enc.Hex.parse(searchParams.get("enc_resp"));
      var key = CryptoJS.enc.Utf8.parse("P1a3y2C5r4a6f7tS")
      let bytes = CryptoJS.AES.decrypt({ ciphertext: rawData }, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
      setData(JSON.parse(atob(bytes.toString(CryptoJS.enc.Base64)).trim()))
      if (!location?.state?.search)
        history.replace("/payment_gateway", {
          search: location.search
        })
    }
    // eslint-disable-next-line
  }, [location.search, location.state?.search])

  useEffect(() => {
    const interval = setTimeout(() => {
      if (time === 0) {
        window.close()
      }
      if (time > 0)
        setTime(b => b - 1)
    }, 1000);

    return () => {
      clearTimeout(interval)
    }
  }, [time])
  return (!data?.txnCode ? null :
    <div style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      fontSize: 16,
      marginBottom: 25,
      textAlign: "center"
    }}>
      <img src={data?.txnCode === "00" ? success : failed} alt="" style={{
        padding: "2rem 0"
      }} width={data?.txnCode === "00" ? 200 : 100} />
      <p style={{ color: "#333" , fontSize: 30, fontWeight: 600, marginBottom: 15 }}>Payment {data?.txnCode === "00" ? "Successful" : "Unsuccessful"}.</p>

      {data?.txnMessage}
      <br />
      {"Redirecting back in "} {time} seconds
      <br />
      <p></p>
    </div>
  );
};

export default PaymentGateway;